<template lang="pug">
.container.container_mobile
  .grid.grid_h-center.grid_v-margins
    .grid__col.grid__col_lg-24.grid__col_xl-20
      .block.block_wide(ref="block")
        .block__item.block__intro
          .block__intro-item.block__intro-item_md
            h2 Недавние тренировки
          .block__intro-item.block__intro-item_md(v-show="showFilters")
            .filters.d-none.d-md-block
              .filters__wrap
                .filters__container
                  .filters__item(v-if="showDisciplineFilter")
                    .filter
                      .filter__label Тип тренировки:
                      .filter__value
                        Select(
                          v-model="filters.discipline.val",
                          :value="filters.discipline.val",
                          :options="disciplinesFilterValues",
                          type="simple",
                          size="sm",
                          :searchable="false",
                          cls="multiselect_dropdown-auto",
                          @input="() => { filtersMobile.discipline.val = filters.discipline.val; updateItems() }"
                        )
                  .filters__item(v-if="showCityFilter")
                    .filter
                      .filter__label Город участника:
                      .filter__value
                        Select(
                          v-model="filters.location.val",
                          :value="filters.location.val",
                          :options="citiesFilterValues",
                          type="simple",
                          size="sm",
                          :searchable="false",
                          cls="multiselect_dropdown-auto",
                          @input="() => { filtersMobile.location.val = filters.location.val; updateItems() }"
                        )
            .filters.filters_mobile.d-md-none
              .filters__wrap
                .filters__container
                  .filters__item(v-if="showDisciplineFilter")
                    MobileFilter(
                      v-model="filtersMobile.discipline.val"
                      :text="getOptionName(disciplinesFilterValues, filters.discipline.val)"
                      :initialValue="filters.discipline.val"
                      name="Тип тренировки"
                      @change="val => { filters.discipline.val = val; updateItems() }"
                    )
                      template(slot="filter")
                        Radio(
                          v-for="option in disciplinesFilterValues"
                          :key="option.id"
                          class="w-100"
                          v-model="filtersMobile.discipline.val"
                          :value="option.id"
                          :label="option.name"
                        )
                  .filters__item(v-if="showCityFilter")
                    MobileFilter(
                      v-model="filtersMobile.location.val"
                      :text="getOptionName(citiesFilterValues, filters.location.val)"
                      :initialValue="filters.location.val"
                      name="Город участника"
                      @change="val => { filters.location.val = val; updateItems() }"
                    )
                      template(slot="filter")
                        Radio(
                          v-for="option in citiesFilterValues"
                          :key="option.id"
                          class="w-100"
                          v-model="filtersMobile.location.val"
                          :value="option.id"
                          :label="option.name"
                        )
          .block__intro-item
            .trainings
              .trainings__item(v-for="training in clubTraining")
                .grid.grid_gutters-sm.grid_v-margins
                  .grid__col.grid__col_stretch
                    .trainings__header
                      Member(
                        :userId="training.userId"
                        :name="training.fullName",
                        :img="training.avatarSmallUrl"
                      )
                        template
                          .text-xs {{ training.location }}
                    Training(
                      :data="userTraining",
                      v-for="userTraining in training.trainings"
                    )
                  .trainings__map.grid__col.grid__col_auto(
                    v-for="userTraining in training.trainings"
                  )
                    .map(
                      v-if="userTraining.intervals && userTraining.intervals.length > 0 && userTraining.intervals[0].mapData",
                      :id="userTraining.intervals[0].activityId"
                    ) {{ createMap(userTraining.intervals[0]) }}
            InfiniteLoading(
              :identifier="infiniteId",
              @infinite="infiniteLoader"
            )
              .loader(slot="spinner")
              div(slot="no-more")
              div(slot="no-results")
                section.empty-state
                  .section__group.mt-0
                    .section__item Нет тренировок под&nbsp;ваш запрос
</template>

<script>
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex'
import Training from '@/components/Training'
import Select from '@/components/Select'
import Member from '@/components/Member'
import L from 'leaflet'
import 'polyline-encoded/Polyline.encoded'
import champsService from '../../services/champsService'
import InfiniteLoading from 'vue-infinite-loading'
import Radio from '@/components/Radio'
import MobileFilter from '@/components/MobileFilter'

export default {
  name: 'ClubTrainings',
  components: {
    Select,
    Training,
    Member,
    InfiniteLoading,
    MobileFilter,
    Radio
  },
  props: {
    club: Object
  },
  data () {
    return {
      clubCode: null,
      settings: {
        page: 1,
        pageSize: 4
      },
      infiniteId: 0,
      filters: {
        discipline: {
          val: 'any'
        },
        location: {
          val: 'any'
        }
      },
      filtersMobile: {
        discipline: {
          val: 'any'
        },
        location: {
          val: 'any'
        }
      },
      maps: []
    }
  },
  computed: {
    ...mapState('club', [
      'clubActivitiesCount'
    ]),
    ...mapState('clubTraining', [
      'clubTraining',
      'clubTrainingCount',
      'clubTrainingsLoaded'
    ]),
    ...mapGetters('clubTraining', [
      'citiesFilterValues',
      'disciplinesFilterValues'
    ]),
    showDisciplineFilter () {
      return this.disciplinesFilterValues.length > 2
    },
    showCityFilter () {
      return this.club &&
        this.club.membersCount > 1 &&
        this.clubActivitiesCount > 1 &&
        this.citiesFilterValues.length > 1
    },
    showFilters () {
      return this.showDisciplineFilter ||
        this.showCityFilter
    }
  },
  methods: {
    ...mapActions('clubTraining', [
      'getClubTraining',
      'getClubTrainingCount',
      'getTrainingFilters',
      'clearClubTraining'
    ]),
    ...mapMutations('clubTraining', ['setTrainingsLoadedStatus']),
    getOptionName (options, id) {
      if (!id) {
        return null
      }
      for (let i = 0; i < options.length; i += 1) {
        const option = options[i]
        if (option.id === id) {
          return option.name
        }
      }
      return null
    },
    createMap (data) {
      if (this.maps.indexOf(data.activityId) !== -1) {
        return
      }
      this.$nextTick(() => {
        this.maps.push(data.activityId)
        const map = L.map(data.activityId)

        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          maxZoom: 18,
          accessToken:
            'pk.eyJ1IjoibWFwYm94IiwiYSI6ImNpejY4NXVycTA2emYycXBndHRqcmZ3N3gifQ.rJcFIG214AriISLbB6B5aw',
          attribution:
            '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        }).addTo(map)

        const latlngs = L.Polyline.fromEncoded(data.mapData).getLatLngs()
        const polyline = L.polyline(latlngs, { color: '#F75A06' }).addTo(map)

        map.fitBounds(polyline.getBounds())
      })
    },
    infiniteLoader ($state) {
      this.loadItems($state)
    },
    loadItems (infiniteState) {
      if (this.clubTrainingsLoaded) {
        if (infiniteState) {
          infiniteState.loaded()
          infiniteState.complete()
        }
        return
      }
      champsService.cancelGettingTraining()
      const { setByFilterValue, getClubTraining } = this
      const disciplineCode = this.filters.discipline.val
      const city = this.filters.location.val
      this.settings.page =
        Math.floor(this.clubTraining.length / this.settings.pageSize) + 1
      const data = {
        clubCode: this.clubCode,
        page: this.settings.page,
        pageSize: this.settings.pageSize,
        disciplineCode: disciplineCode === 'any' ? null : disciplineCode,
        city: city === 'any' ? null : city
      }

      setByFilterValue(this.filters.location.val, data, 'city')
      setByFilterValue(this.filters.discipline.val, data, 'disciplineCode')

      getClubTraining({ data, clubCode: this.clubCode })
        .then(() => {
          if (this.clubTraining.length === 0) {
            infiniteState && infiniteState.complete()
          } else {
            infiniteState && infiniteState.loaded()
            if (
              this.clubTraining.length -
                this.settings.page * this.settings.pageSize <
              0
            ) {
              infiniteState && infiniteState.complete()
              this.setTrainingsLoadedStatus(true)
            }
          }
        })
        .catch((response) => {
          if (response.message !== 'canceled') {
            infiniteState && infiniteState.complete()
            this.isLoading = false
            this.isSearching = false
          }
        })
    },
    setByFilterValue (value, data, dataPropName) {
      if (value !== 'any') {
        data[dataPropName] = value
      }
    },
    updateItems () {
      this.maps = []
      this.settings.page = 1
      this.setTrainingsLoadedStatus(false)
      this.clearClubTraining()
      this.loadItems()
      this.infiniteId++
    }
  },
  watch: {
    clubActivitiesCount (val) {
      if (!val) {
        this.$router.replace({
          name: 'Club',
          params: {
            id: this.$route.params.id || this.$getTenantIdClub()
          }
        })
      }
    }
  },
  created () {
    this.clubCode = this.$route.params.id || this.$getTenantIdClub()
    this.getTrainingFilters({ clubCode: this.clubCode })
    this.loadItems()
  }
}
</script>

<style lang="scss" scoped>
.trainings {
  &__item {
    margin-bottom: 12px;
    padding: 12px 0;

    @media (min-width: breakpoint(lg)) {
      padding: 24px 0;
    }
  }

  &__header {
    margin-bottom: 12px;
  }

  &__map {
    @media (max-width: 991px) {
      width: 100%;
    }
  }

  .map {
    width: 100%;
    height: 100%;
    min-height: 200px;

    @media (min-width: 992px) {
      width: 240px;
    }

    @media (min-width: breakpoint(lg)) {
      width: 280px;
    }
  }
}

.filters_mobile {
  margin-left: -24px;
  margin-right: -24px;
  padding-left: 24px;
  padding-right: 24px;
}
</style>
